import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from "axios";
import "./registerServiceWorker";
import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { fab } from "@fortawesome/free-brands-svg-icons";
import { fas } from "@fortawesome/free-solid-svg-icons";
import Vuetify from "vuetify";
import "vuetify/dist/vuetify.min.css";
import Vuelidate from "vuelidate";
import VueMatchHeights from "vue-match-heights";
import CookieLaw from 'vue-cookie-law'

Vue.component('cookie-law', CookieLaw )

Vue.use(Vuelidate);
Vue.use(Vuetify);
library.add(fab);
library.add(fas);

Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.config.productionTip = false;

window.$ = require("jquery");
const base = axios.create({
  baseURL: "https://api.giros.ro/api"
  // baseURL: "https://api.mvp-site.agentiawebmagnat.ro/api"
});
Vue.prototype.$http = base;

Vue.use(VueMatchHeights, {
  disabled: [768]
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
